module.exports = "/_next/static/images/envelope-duotone-f9e98ce672b3ed092b93081a293d4574.svg";